import React from 'react';
import { withStyles } from '@material-ui/styles';
import FormControl from '@material-ui/core/FormControl';

const ValidationFormControl = withStyles({
  root: {
    "& label, label.Mui-focused": {
      color: "#162954"
    },
    "& label.Mui-error": {
      color: "red"
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#162954"
    },
    "& .MuiInput-underline.Mui-error:after": {
      borderBottomColor: "red"
    }
  }
})(FormControl);

export default ValidationFormControl;